import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import { FORMS_API_BASE_ENDPOINT } from "./constants";
import { api } from "./apiClient";
import { REGISTRATION_STATUS_VARIANTS } from "./registrations.types";

const BASE_ENDPOINT = `${FORMS_API_BASE_ENDPOINT}/dashboard`;

const keys = {
  all: () => ["dashboard"] as const,
} as const;

export const TopListVariantSchema = z.enum(["categoriesOfPersonalData", "categoriesOfDataSubject", "systems", "units"]);

export type TopListVariant = z.infer<typeof TopListVariantSchema>;

const DataCardVariantSchema = z.enum([
  "thirdCountryTransfers",
  "dataAboutChildren",
  "dataAboutCrime",
  "specialCategoriesOfPersonalData",
  "processorsWithoutProcessorAgreements",
  "systemsWithoutSecurityMeasures",
  "automatedDecisionMaking",
  "theDataSubjectsHaveNotBeenInformed",
]);

export type DataCardVariant = z.infer<typeof DataCardVariantSchema>;

const TopListItemSchema = z.object({ name: z.string(), value: z.number() });

const TopListDataSchema = z.array(TopListItemSchema);

const DashboardResponseSchema = z.object({
  processingsAsControllerByStatus: z.array(z.object({ name: z.enum(REGISTRATION_STATUS_VARIANTS), value: z.number() })),
  numberOfSharedProcessings: z.number().optional(),
  topList: z.record(TopListVariantSchema, TopListDataSchema),
  dataCards: z.array(z.object({ variant: DataCardVariantSchema, value: z.number() })),
});

export type DashboardResponse = z.infer<typeof DashboardResponseSchema>;

export const dashboardQueryOptions = () =>
  queryOptions({
    queryKey: keys.all(),
    queryFn: () => api.get(BASE_ENDPOINT, { schema: DashboardResponseSchema }),
    throwOnError: true,
  });
